// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6356ff51","354":"3db79fef","483":"c07eb0ab","627":"4a5fe063","628":"cbbea632","737":"7236350d","782":"014c6f87","787":"e8865e4a","896":"bdd261aa","942":"5f65baa8","945":"63281ab3"}[chunkId] + ".chunk.js";
};